export class RoleConst{

  public static ASSISTANT:string = 'CANDIDAT';
  public static SPONSOR:string = 'MAITRE_STAGE';
  public static MEMBER:string = 'MEMBRE_GEIMG';
  public static SECRETARY:string = 'SECRETAIRE_GEIMG';

}
